var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-container"},[_c('ProfileSidebar'),_c('div',{staticClass:"page-container"},[_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }